<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </v-toolbar>
    <v-layout row wrap v-if="item">
      <v-flex md6 class="pa-4">
        <div>
          <strong>Name</strong><br />
          <p>{{ item.name }}</p>
        </div>
        <div>
          <strong>Email</strong><br />
          <p>{{ item.email }}</p>
        </div>
        <div>
          <strong>Notes</strong><br />
          <p>{{ item.notes }}</p>
        </div>
      </v-flex>
      <v-flex md6 class="pa-4">
        <div v-if="type == 'coordinator'">
          <strong>Commission %</strong><br />
          <p>{{ item.commission_percent }}</p>
        </div>
        <div>
          <strong>Mobile</strong><br />
          <p>{{ item.mobile }}</p>
        </div>
        <div>
          <strong>Address</strong><br />
          <p>{{ item.address }}</p>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: ["type", "item", "title"],
  // data() {
  //   return {
  //     // relatedFiles: [],
  //   };
  // },

  // computed: {},

  // methods: {},

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
